import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

// Check localStorage first, then sessionStorage for non-persistent sessions
const getStoredUser = () => {
  try {
    const keepSignedIn = localStorage.getItem("keepSignedIn");
    if (keepSignedIn === "true") {
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    } else {
      // Check sessionStorage for temporary session
      const sessionUser = sessionStorage.getItem("user");
      if (sessionUser) {
        return JSON.parse(sessionUser);
      }
      // Fallback to localStorage for backwards compatibility
      const user = localStorage.getItem("user");
      return user ? JSON.parse(user) : null;
    }
  } catch (e) {
    console.error("Error reading stored user:", e);
    return null;
  }
};

const storedUser = getStoredUser();

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: storedUser || null,
    isAuth: !!storedUser,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      state.isAuth = true;
    },
    logOut: (state, action) => {
      state.user = null;
      state.isAuth = false;
      // Clear both storage types on logout
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("keepSignedIn");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
    },
  },
});

export const { setUser, logOut } = authSlice.actions;
export default authSlice.reducer;
